import React from "react";

import { Translate } from "utils";

import styles from "./Loading.css";

const { t } = new Translate();

export default () => <div className={styles.root}>{t("loading")}</div>;
